






















import { PropType } from 'vue';
import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { AdgroupFormData, IOS14QuotaType } from '@tt4b/ttam-enums';

const name = 'ttam-audience-added-viewed-select';
export default defineComponent({
  name,
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    preDesc: {
      type: String,
      default: '',
    },
    appDesc: {
      type: String,
      default: '',
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const daysOptions = ref([1, 2, 3, 7, 14, 30, 60, 90, 180]);
    const selectValue = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });
    const isSupportIos14 = computed(() => adgroupData.value.ios14QuotaType === IOS14QuotaType.OCCUPIED);
    return {
      name,
      daysOptions,
      selectValue,
      isSupportIos14,
    };
  },
});
